import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';

import {ItemsService} from './items.service';

@Component({
  selector: 'app-consume-review',
  templateUrl: './consume-review.component.html'
})
export class ConsumeReviewComponent implements OnInit {

  form = this.fb.group({
    purchasedTimePeriod: [{value: '', disabled: true}],
    timeUomId: [{value: '', disabled: true}],
    purchasedQuantity: [{value: '', disabled: true}],
    usedQuantity: [{value: '', disabled: true}],
    expireDate: [{value: '', disabled: true}],
    effectiveDate: [{value: '', disabled: true}],
  });

  constructor(
    private fb: FormBuilder,
    private itemsService: ItemsService
  ) {
  }

  ngOnInit(): void {
    this.itemsService.getConsumeReview().subscribe((response) => {
      if (response.effectiveDate) {
        response.effectiveDate = new Date(response.effectiveDate);
      }
      if (response.expireDate) {
        response.expireDate = new Date(response.expireDate);
      }
      this.form.patchValue(response);
    });
  }

}
